module.exports = __webpack_public_path__ + "img/icon.c1ab0104.gif";